import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';
import { CookieService } from "ngx-cookie-service";
import { secureStorage } from './secure-storage';

@Injectable({
  providedIn: "root"
})
export class GlobalCurrentUserService {

  checkLoggedIn : BehaviorSubject<boolean>;
  rememberMe = false;
  cookieExpiryDays = 1;

  constructor(private cookieService: CookieService) {
    this.checkLoggedIn = new BehaviorSubject(false);
  }

  setCurrentUser(val, rememberMe?) {
    if(val) this.checkLoggedIn.next(true);
    // localStorage.setItem("currentUser", val);    
    const expiryDate: Date = new Date();
    expiryDate.setDate(expiryDate.getDate()+this.cookieExpiryDays);
    const encr = secureStorage.hash("currentUser");
    const encrVal = secureStorage.encrypt(val);
    rememberMe && this.cookieService.set(encr, encrVal, expiryDate, '/', null, true);
    !rememberMe && this.cookieService.set(encr, encrVal, null, '/', null, true);
  }

  getCurrentUser() {
    // let  val = localStorage.getItem("currentUser"); 
    const encr = secureStorage.hash("currentUser");
    if(this.cookieService.get(encr).length===0){
      return null;
    }
    
    const val = secureStorage.decrypt(this.cookieService.get(encr));
    if(val) this.checkLoggedIn.next(true);
    return val;
  }
}
